<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="pXVI"></a><a id="pXVII"></a>Polygamy</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter_opening.vue?8f40ef7e